<form [formGroup]="itemsFilterForm" role="search">
  <div class="form-group">
    <label
      class="form-label"
      class="input-group-label sr-only"
      for="itemsFilter-form-filter"
      i18n="@@itemsFilter-label-searchItems"
      >Search for items</label
    >
    <div class="input-group">
      <input
        #filterTermInput
        formControlName="filterTerm"
        id="itemsFilter-form-filter"
        name="filter"
        placeholder="Search"
        i18n-placeholder="@@itemsFilter-placeholder-search"
        type="text"
        class="form-control"
        enterkeyhint="search"
      />
      <ng-container>
        <button
          class="btn btn-default"
          type="submit"
          title="Submit search"
          i18n-title="@@itemsFilter-title-submitSearch"
        >
          <i class="fas fa-search" aria-hidden="true"></i>
          <span class="sr-only" i18n="@@itemsFilter-btn-search">Search</span>
        </button>
      </ng-container>
    </div>
  </div>
</form>
